import BaseEntityModelFilter from "../../general/BaseEntityModelFilter";
import store from "../../../store";

export default class MonitorScoreExamsFilter extends BaseEntityModelFilter {
  constructor() {
    super();
    this.setInitialValue();
  }
  setInitialValue() {
    this.setFilterInitialValue();
    this.activationTypeTokens =
      store.getters.generalSetting.monitorScoreExams.activationTypeTokens || [];
    this.educationalGroupToken = "";
    this.educationalGroupStudentToken = "";
    this.userStudentInfoDataInclude = true;
    this.educationalGroupInfoDataInclude = true;
    this.educationalCategoryInfoDataInclude = true;
  }
  fillData(data) {
    if (data) {
      this.fillFilterData(data);
      this.educationalGroupToken = data.educationalGroupToken ?? "";
      this.educationalGroupStudentToken =
        data.educationalGroupStudentToken ?? "";
      this.userStudentInfoDataInclude = data.userStudentInfoDataInclude ?? true;
      this.educationalGroupInfoDataInclude =
        data.educationalGroupInfoDataInclude ?? true;
      this.educationalCategoryInfoDataInclude =
        data.educationalCategoryInfoDataInclude ?? true;
    } else {
      this.setInitialValue();
    }
  }
}
